import outsideSlab, { OutsideSlabSection } from '../../../../../sections/slabSections/outsideSlab';

export const createBasementLevelOutsideSlabSection = (outsideSurface: number): OutsideSlabSection =>
  outsideSlab({ surface: outsideSurface });
